import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID, ViewChild, ElementRef, ChangeDetectorRef, AfterViewChecked, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import {Observable} from 'rxjs/Observable';
declare var $: any;
//services
import {StoreService} from 'src/app/services/store.service';
import {SharedService} from 'src/app/services/shared.service';
import {SEOService} from 'src/app/services/seo.service';
import {AnalyticsService} from 'src/app/services/analytics.service';
import { config } from '../../../config';
import { LoginService } from 'src/app/services/login.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit, AfterViewChecked {
  cartData: Observable<any>;
  data: Observable<any>;
  user: Observable<any>;
  totalItem: number;
  schedule: Observable<any>;
  selected_policy: any;

  toggleActive: boolean = false;
  isNavbarClicked = false;

  bsModalRef: BsModalRef;
  
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private storeService: StoreService,
    private sharedService: SharedService,
    private seoService: SEOService,
    private analyticsService: AnalyticsService,
    private loginService: LoginService,
    private renderer: Renderer2,
    public modalService: BsModalService,
  ) {
    /**RESTORE POLICY IN REDUX STORE UPON REFRESH**/
    this.storeService.storeExistingSelectedPolicy(); // restore existing selected policy
    this.storeService.storeExistingDeliveryTime(); // restore existing delivery time
    this.storeService.setExistingPaymentMethod(); // restore existing delivery time
    this.storeService.storeExistingCartData(); // restore existing cart data
    this.storeService.storeExistingAvailablePromotion(); // restore existing available promotion data
    this.storeService.storeExistingAcceptedPromotion(); // restore existing accepted promotion data
    this.storeService.storeExistingOrderNotes(); // restore existing accepted promotion data
    this.storeService.storeExistingLoginData(); // restore existing accepted promotion data
    this.storeService.storeExistingResCartData(); // restore existing reservation cart data
    this.storeService.storeExistingResMenu(); // restore existing restaurant menu dish

    this.schedule = this.storeService.schedule;
    this.data = this.storeService.restaurantData;
    this.user = this.storeService.user;

    /**CHECK RESTAURANT INFORMATION IN REDUX STORE THEN, GENERATE RESTAURANT SCHEDULE**/
    this.data.subscribe(result => {
      if (Object.getOwnPropertyNames(result).length !== 0) {        
        
        const homePageData = result?.restaurant_content?.home_page;
        if (homePageData) {
          this.seoService.setPageTitle(homePageData.seo_page_title);// set page title
          this.seoService.addMetaTag(homePageData.seo_meta); // meta data
          this.analyticsService.init(homePageData.google_analytics);
          this.analyticsService.createSchema(homePageData.schema);
          this.analyticsService.createCustomJavaScript(homePageData.custom_content);
          
          this.analyticsService.createCustomNoScript(homePageData.custom_no_script);
        }
      }
    });
    /**END**/
  }

  ngOnInit() {
    
  }

  closeNavbar() {
    const navbarCollapse = document.getElementById('navbarSupportedContent');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      this.renderer.removeClass(navbarCollapse, 'show');
    }
  }

  ngAfterViewInit() {
    
  }

  ngAfterViewChecked() {}

  navBarClicked(){
    // this.isNavbarClicked = !this.isNavbarClicked;
  }

  navigateUrl(){
    this.router.navigateByUrl("/")
  }

  signOut() {
    if (this.platformId === 'browser') {
      document.body.classList.toggle('active-nav');
    }
    this.toggleActive = !this.toggleActive;
    this.loginService.logOut();
  }

  
}

